var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoveryFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49718 3.00618C4.11757 3.00773 3 4.12656 3 5.50617V9.99997C3 10.5523 3.44772 11 4 11H10C10.5523 11 11 10.5523 11 9.99997V4.0011C11 3.44837 10.5516 3.00048 9.99887 3.0011L5.49718 3.00618ZM3.99887 13.0079C3.44703 13.0085 3 13.456 3 14.0079V18.5C3 19.8807 4.11929 21 5.5 21H10C10.5523 21 11 20.5523 11 20V14.0011C11 13.4484 10.5516 13.0005 9.99887 13.0011L3.99887 13.0079ZM13 4.01773C13 3.46644 13.4462 3.01914 13.9975 3.01774L18.4937 3.00633C19.8768 3.00282 21 4.12313 21 5.50632V18.5C21 19.8807 19.8807 21 18.5 21H14C13.4477 21 13 20.5523 13 20V4.01773Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoveryFilled);
export default __webpack_public_path__ + "static/media/discoveryFilled.14b6da73c6b0532eb5a18224c4d7f5b0.svg";
export { ForwardRef as ReactComponent };